function makeDelay (ms) {
    return new Promise(res => setTimeout(res,ms));
}

export default makeDelay;
